module.exports = __webpack_public_path__ + "static/mb-2e12687e639cfbf6432a774b3565c43d.webm";